import { VStack } from '../..';

/**
 * 페이지 안에서 헤더 다음으로 나오는 컨텐츠 영역.
 *
 * @package
 */
export const Body = (props: React.ComponentProps<typeof VStack>) => {
  return <VStack p={2} gap={2} {...props} />;
};
